/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum PaymentTokenStatus {
	Unspecified = 'Unspecified',
	PendingPayment = 'PendingPayment',
	PendingSaveCard = 'PendingSaveCard',
	PendingAction = 'PendingAction',
	Confirmed = 'Confirmed',
	AuthenticationSucceeded = 'AuthenticationSucceeded',
	AuthenticationFailed = 'AuthenticationFailed',
}
